import React from "react";
import styles from "./GridBackground.module.scss";

const GridBackground = (props) => {
  const { children } = props;


  return (
    <div className={styles.container}>
      <div className={styles.pattern}/>
      <div className={styles.gradient}/>
      <div className={styles.patternContent}>
        {children}
      </div>
    </div>
  );
};

export default GridBackground;
